//固縛ベルトの分岐
if (
  thispageURL.indexOf("filter.p.m.products._type=lashingbelt") >= 0 ||
  thispageURL.indexOf("collections/lashingbelt") >= 0
) {
  $(".parts_smp_search01").css("display", "block");
}

//吊荷ベルトの分岐
if (
  thispageURL.indexOf("filter.p.m.products._type=hanging_loads") >= 0 ||
  thispageURL.indexOf("filter.p.m.products._spec=slingbelt") >= 0 ||
  thispageURL.indexOf("filter.p.m.products._spec=roundsling") >= 0 ||
  thispageURL.indexOf("collections/slingbelt") >= 0
) {
  $(".parts_smp_search02").css("display", "block");
}
